import { render, staticRenderFns } from "./StadiumBoostInsertCustomerForm.vue?vue&type=template&id=63b1bd11&"
import script from "./StadiumBoostInsertCustomerForm.vue?vue&type=script&lang=js&"
export * from "./StadiumBoostInsertCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b1bd11')) {
      api.createRecord('63b1bd11', component.options)
    } else {
      api.reload('63b1bd11', component.options)
    }
    module.hot.accept("./StadiumBoostInsertCustomerForm.vue?vue&type=template&id=63b1bd11&", function () {
      api.rerender('63b1bd11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumBoostInsertCustomerForm.vue"
export default component.exports